export default __webpack_public_path__ + "934a317f073408b6d3a8127ae4e6b9b9.png";